import React from 'react';

import { PortfolioAnalysisSurveySummary } from '../store';
import styles from '../PortfolioAnalytics.module.scss';
import { Form } from '../../../shared/icons';
import { ConfirmationModal } from '../../../shared/modal/ConfirmationModal';
import { ModalHeader } from '../../../shared/modal/ModalHeader';
import { Scrollable } from '../../../shared/scrollable/Scrollable';

interface PortfolioAnalyticsMetaModalProps {
    modalOpen: boolean;
    closeModal: () => void;
    summary: PortfolioAnalysisSurveySummary
}

export const PortfolioAnalyticsMetaModal: React.FC<PortfolioAnalyticsMetaModalProps> = ({ modalOpen, closeModal, summary: { agreementType, documentNames, fieldLabel, questionAsked } }) => (
    <ConfirmationModal
        isOpen={modalOpen}
        closeModal={closeModal}
        closeLabel='Close'
        showConfirm={false}
    >
        <div className={styles.portfolioMetaModalWrapper}>
            <ModalHeader
                testId='portfolio-analytics-meta-modal'
                label='Information Provided'
                icon={Form}
            />
            <div className={styles.scrollableWrapper}>
                <Scrollable maxHeight='60vh'>
                    <div className={styles.metaWrapper}>
                        <div className={styles.metaLabel}>Agreement Type</div>
                        <div className={styles.metaValue}>{agreementType}</div>
                    </div>
                    <div className={styles.metaWrapper}>
                        <div className={styles.metaLabel}>Document Names</div>
                        {documentNames.map((documentName) => (
                            <div key={documentName} className={styles.metaValue}>{documentName}</div>
                        ))}
                    </div>
                    <div className={styles.metaWrapper}>
                        <div className={styles.metaLabel}>Selected Field</div>
                        <div className={styles.metaValue}>{fieldLabel}</div>
                    </div>
                    <div className={styles.metaWrapper}>
                        <div className={styles.metaLabel}>Question Asked</div>
                        <div className={styles.metaValue}>{questionAsked}</div>
                    </div>
                </Scrollable>
            </div>
        </div>
    </ConfirmationModal>
);
